<template>
    <v-card class="mx-auto" shaped elevation="0" flat>
        <v-card-title>
            Información De Usuario
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-form ref="form">
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-row dense align="center" justify="center">
                                <v-col cols="12" sm="2">
                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" v-on="on" @click="onOpenExplorer" :disabled="disabled">
                                                <v-icon>add_photo_alternate</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Cambiar Foto</span>
                                    </v-tooltip>
                                    <input type="file" accept="image/png,image/jpeg,image/jpg" hidden id="photoPerfil"
                                        @change="loadFile" />
                                </v-col>
                                <v-col cols="12" sm="8">
                                    <div v-if="_.size(obForm.base64) == 0">
                                        <v-img src="@/assets/img/user.png" max-width="200" min-height="200" max-height="200"  contain></v-img>
                                    </div>
                                    <div v-else>
                                        <v-img :src="obForm.base64" max-width="200" min-height="200" max-height="200"  contain></v-img>
                                    </div>
                                    <div class="text-center mt-1">
                                        <h3 v-html="obForm.nombre"></h3>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="8">
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="N° de Documento" color="textbox" v-model="obForm.nroDocumento"
                                        outlined dense disabled />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Nacionalidad" color="textbox" v-model="obForm.nacionalidad"
                                        outlined dense disabled />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Estado Civil" color="textbox" v-model="obForm.estadoCivil" outlined
                                        dense disabled />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Fecha de Nacimiento" color="textbox"
                                        v-model="obForm.fechaNacimiento" outlined dense disabled />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Profesión" color="textbox" v-model="obForm.profesion" outlined
                                        dense readonly />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Genero" color="textbox" v-model="obForm.genero" outlined dense
                                        disabled />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Teléfono" color="textbox" v-mask="maskTelefono" v-model="obForm.telefonoPBX" outlined
                                        dense :rules="requeridoRegla"/>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field label="Celular" color="textbox" v-mask="maskCelular" v-model="obForm.celular" outlined dense 
                                        :rules="requeridoRegla"/>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Email para recibir mis documentos, notificaciones, etc." color="textbox" v-model="obForm.email" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-autocomplete label="Cantón *" color="textbox" :items="listGeneral.listCanton"
                                item-text="canton" item-value="idCanton" v-model='obForm.idCanton' outlined dense
                                :rules="requeridoRegla" />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-text-field label="Dirección" color="textbox" v-model="obForm.direccion" outlined dense
                                :rules="requeridoRegla" />
                        </v-col>
                    </v-row>
                </v-form>
                <v-row dense>
                    <v-col cols="12" class="text-right">
                        <v-btn rounded dark color="primary" :disabled="disabled"  @click="validar">
                                Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';
    export default {
        name: 'WindowItemInformacionComponent',
        directives:{mask},
        data: () => ({
            obForm: {
                nroDocumento: null,
                usuario:null,
                nombre: null,
                nacionalidad: null,
                estadoCivil: null,
                fechaNacimiento: null,
                profesion: null,
                genero: null,
                telefonoPBX: null,
                celular: null,
                email: null,
                idCanton: null,
                direccion: null,
                base64:null
            },
            listGeneral: {
                listCanton: []
            },
            maskTelefono: "#########",
            maskCelular: "##########",
            disabled:false
        }),
        created() {
            var error = 'E';

            this.onListarInformacion()
                .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        return axios.post(`${BASE_URI}administrador/canton/listar`,{opcion:'L'});
                })
                .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.listGeneral.listCanton = r.data.data;
                })
                .catch((e)=>{
                    mensajesAlerta(e,error);
                });
        },
        methods: {
            onListarInformacion(){
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/usuario/listar`,{opcion:'LISTAR_CON',loadFile:true})
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    this.$set(this,'obForm',_.merge({},this.obForm,r.data.data[0]));
                                    
                                return r;
                            })
                            .catch((e)=>{
                                return e;
                            });
            },
            onOpenExplorer() {
                var input = document.getElementById('photoPerfil');
                input.click();
            },
            loadFile(e) {
                try {
                    this.disabled = true;
                    var files = e.target.files;
                    var band = true;

                    if (_.isUndefined(files[0])) throw mensajeEstandar.archivo;
                        var name = files[0].name;

                    if (name.lastIndexOf('.') <= 0) throw mensajeEstandar.archivo;

                    if(_.includes(name,'.png')) band = false;
                    if(_.includes(name,'.jpg')) band = false;
                    if(_.includes(name,'.jpeg')) band = false;
                    
                    if (band) throw mensajeEstandar.archivo;

                        var fr = new FileReader()
                        fr.readAsDataURL(files[0])
                        fr.addEventListener('load', () => {
                            var o = { opcion:'U',idUsuario: this.obForm.id_usuario, base64: fr.result, idEstado:1 }
                            this.guardar('administrador/usuario/insertOrUpdate',o);
                        });

                } catch (error) {
                    mensajesAlerta(error, 'I');
                    this.disabled = false;
                }
            },
            validar(){
                try {
                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        var url = 'administrador/usuario/update';
                        var idCLiente = _.get(this.$root.obUsuario,'idCliente',null);
                        var o = _.merge({},
                                        {tipo:_.size(idCLiente) > 0 ? 'C' : 'O', idCLiente },
                                        _.pick(this.obForm,['idCanton','telefonoPBX','celular','email','direccion'])
                                    );
        
                        this.guardar(url,o);
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            guardar(url,o) {
                try {
                    this.disabled = true;
                    axios.post(`${BASE_URI}${url}`,o)
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                    mensajeAlertaTiempo('Se actualizo la información correctamente','S');
                                    return this.onListarInformacion();
                            })
                            .then((r)=>{
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                    this.disabled = false;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,'E');
                                this.disabled = false;
                            });
                } catch (error) {
                    this.disabled = false;
                    mensajesAlerta(error,'I');
                }
            }
        },
    }
</script>